exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".toast-alert{position:fixed;left:50%;top:20px;transform:translate(-50%, 0);-webkit-transform:translate(-50%, 0);z-index:99999}.toast-alert .close{margin-left:10px}", ""]);

